// extracted by mini-css-extract-plugin
export default {"button":"jl-z","reviewSort":"kl-z"};